document.addEventListener('DOMContentLoaded', () => {

    const init = () => {
        document.documentElement.classList.add('is-loaded');
        setTimeout(() => {
            window.location.hash ? window.runScroll( '#'+document.getElementById(window.location.hash.substring(1)).id ) : false;
            window.carousels();
            document.getElementById('cover').remove();
            document.querySelector('#development') ? window.development() : false;
        }, 150);  
    };
    
    window.addEventListener('load', init);

}, false);